import { handleChange } from "./datePickerChange.tsx";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { DateObject } from "react-multi-date-picker";
export const MiladyToShamsi = (value, setValue) => {
    const defaultValue = new DateObject({
        date: new Date(value),
        calendar: persian, 
        locale: persian_fa, 
    });

    handleChange(defaultValue, setValue)
}